module.exports = {


  footerText: '®2022 Todos los derechos reservados. &nbsp; &nbsp;  Desarrollado por Intersistemas, S.A. de C.V.',
  version: 'v2.3.1'

};
